import { useRef, useEffect } from 'react';
import { useFeatureFlagVariantKey, usePostHog } from 'posthog-js/react';
import { HeroControl, HeroVariantA, HeroVariantB } from './HeroVariants';

/**
 * Hero Section with A/B Testing
 * WP-LANDING-5: Uses PostHog feature flags to select variant
 * Calculator immediately follows hero, no scroll-to-calculator needed
 */
export function HeroSection() {
  const posthog = usePostHog();
  const hasTrackedRef = useRef(false);

  // Get variant from PostHog using official React hook
  // This hook properly handles async loading and triggers re-render when flags load
  const variant = useFeatureFlagVariantKey('landing_hero_variant') ?? 'control';

  // Track variant exposure (once per page load)
  useEffect(() => {
    if (!hasTrackedRef.current && posthog) {
      posthog.capture('landing_hero_viewed', { variant });
      hasTrackedRef.current = true;
    }
  }, [variant, posthog]);

  // Render appropriate variant
  switch (variant) {
    case 'variant_a':
      return <HeroVariantA />;
    case 'variant_b':
      return <HeroVariantB />;
    case 'control':
    default:
      return <HeroControl />;
  }
}
